import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=9e094700&scoped=true"
import script from "./channels.vue?vue&type=script&lang=js"
export * from "./channels.vue?vue&type=script&lang=js"
import style0 from "./channels.vue?vue&type=style&index=0&id=9e094700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e094700",
  null
  
)

export default component.exports